/** @jsxImportSource theme-ui */

import { Text, Title } from "@bottlebooks/gatsby-design-system";
import { Button, Dialog } from "@bottlebooks/gatsby-theme-base/src";
import { Trans } from "@lingui/macro";
import type { DialogProps } from "@reach/dialog";
import { X, XCircle } from "@phosphor-icons/react";
import { Fragment } from "react";
import type { RequestMeetingDialogData } from "./RequestMeetingButton.Dialog.next";
import type { ErrorActions } from "./RequestMeetingButton.useState";

type ErrorProps = ErrorActions & {
  profile: RequestMeetingDialogData;
  onDismiss: DialogProps["onDismiss"];
};

export default function RequestMeetingSubmissionError({
  message,
  onRetry,
  onDismiss,
  profile,
}: ErrorProps) {
  return (
    <Fragment>
      <Dialog.Header onDismiss={onDismiss}>
        <Trans>Book a meeting with {profile.displayName}</Trans>
      </Dialog.Header>
      <Dialog.Content sx={{ textAlign: "center" }}>
        <XCircle size={64} weight="light" sx={{ color: "brand.warningRed" }} />
        <Title variant="small" sx={{ marginBottom: 3 }}>
          <Trans>An error has occurred.</Trans>
        </Title>
        <Text variant="small">{message}</Text>
      </Dialog.Content>
      <Dialog.Footer justify="space-between">
        {onRetry && (
          <Button variant="secondary" onClick={onRetry}>
            <Trans>Back</Trans>
          </Button>
        )}
        <Button variant="primary" onClick={onDismiss}>
          <X size={22} weight="light" sx={{ marginRight: 1 }} />
          <Trans>Close</Trans>
        </Button>
      </Dialog.Footer>
    </Fragment>
  );
}
